































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { StoreViewModel,AccountNumbersList } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import { VHeaders } from '@/models/pagedlistmodel';
import { IDialogOption } from '@/models/dialog';
import { PaginationModel } from '@/models/pagedlistmodel';
import {accountService,storeService} from '@/shared';

@Component({
    computed: {
        isValidate() {
            return this.selectedStore && this.selectedAccountType;
        },
        isError() {
            this.accountDialog.action.disable = (this.errors.any()) ? true : false;
        },
    },
    components: {
        Grid: () => import('@/components/common/app.grid.vue'),
        AppDialog: () => import('@/components/common/app.dialog.vue'),
    },
})
export default class StoreAccount extends Base {
    public storeAccountTypes: any[] = [
        { name: 'CIT', value: 1 },
        { name: 'AR', value: 2 },
    ];
    public stores: StoreViewModel[] = [];
    public terminalLocations: any[] = [];
    public store: any;
    public accounts: AccountNumbersList[] =  [];
    public account: string = '';
    public errors: any;
    public accountDialog: IDialogOption = {
        width: 500,
        title: this.$parent.$t('accountList.accountDialog.title') as string,
        model: false,
        loading: false,
        action: {
            color: 'success', icon: 'fas fa-check', text: this.$parent.$t('accountList.accountDialog.addAccount') as string,
        },
        onAction: (): void => {
            this.updateAccount(true);
        },
    };
    public accountNumber: string = '';
    public deleteDialog: IDialogOption = {
        width: 400,
        title: this.$parent.$t('accountList.deleteDialog.title') as string,
        model: false,
        loading: false,
        action: { color: 'success', icon: 'fas fa-check', text: this.$parent.$t('accountList.deleteDialog.btnAgree') as string },
        onAction: (): void => {
            this.updateAccount(false);
        },
    };
    public pagination: PaginationModel = new PaginationModel('accountNumber');

    public selectedStore: string = '';
    public selectedAccountType: string = '';
    public storeId: string = '';
    public loading: boolean = false;
    public storeLoading: boolean = false;
    public headers: VHeaders[] = [
        {
            text: this.$parent.$t('accountList.storeAccountsGrid.accountNumber') as string,
            value: 'accountNumber',
            sortable: false,
        },
        {
            text: this.$parent.$t('accountList.storeAccountsGrid.action') as string,
            isNotDataProp: true,
            sortable: false,
        },
    ];
    public actions: any[] = [{
        type: 'button',
        icon: 'fas fa-trash-alt',
        title: this.$parent.$t('accountList.storeAccountsGrid.gridActions.delete') as string,
        color: 'error',
        visible: (model: any) => true,
        action: (model: any) => {
            this.deleteConfirmDialogOpen(model);
        },
    }];

    public mounted() {
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'dealAccount');

        const storeId = this.$route.params.storeid;
        this.selectedAccountType = '';
        if (storeId != null && storeId !== '' && storeId !== '0') {
            this.getAllStores(storeId);
        } else {
            this.getAllStores();
        }
    }

    public async getAllStores(storeId: string = ''): Promise<void> {
        try {
            this.storeLoading = true;
            const response = await storeService.getStoresList();
            this.stores = response.results;
        } finally {
            this.storeLoading = false;
        }
    }

    public async getStoreById(selectedStore): Promise<void> {
        this.selectedStore = selectedStore;
        if (this.selectedStore != null && this.selectedStore !== '') {
            try {
                this.loading = true;
                const response = await storeService.getStore(
                    Number(this.selectedStore),
                );
                this.store = response;
                this.updateAccountVariable();
            } finally {
                this.loading = false;
            }
        } else {
            this.showAlert(false, this.$t('accountList.alertSelectAtleastOneStore'));
        }
    }

    public clear(): void {
        this.accounts = [];
    }

    public storeChange(selectedStore): void {
        this.clear();
        this.getStoreById(selectedStore);
    }

    public accountTypeChange(selectedAccountType): void {
        this.clear();
        const data = this.selectedAccountType;
        this.selectedAccountType = selectedAccountType;
        this.updateAccountVariable();
    }

    public async updateAccount(isAdd: boolean): Promise<void> {
        const accountNumber = this.accountNumber;
        this.loading = true;
        if (this.selectedAccountType != null && this.selectedAccountType == '1') {
            // Initialize CIT if empty
            if (!this.store.dealAccountInfoJson.citAccountNumbers) {
                this.store.dealAccountInfoJson.citAccountNumbers = { accountNumber: [] };
            }
            // Add CIT Account Number
            if (isAdd) {
                if (this.accountNumber == '') {
                    this.showAlert(false, this.$t('accountList.alertAccountNumberIsRequired'));
                    return;
                }
                this.store.dealAccountInfoJson.citAccountNumbers.push(this.accountNumber);
                this.accountNumber = '';
                this.accountDialog.model = false;
            } else {
                this.deleteDialog.model = false;
                this.store.dealAccountInfoJson.citAccountNumbers =  this.store.dealAccountInfoJson.citAccountNumbers.filter(item => item != this.accountNumber);                }
        } else if (

            this.selectedAccountType != null &&
            this.selectedAccountType == '2'
        ) {
            // Initialize AR if empty
            if (!this.store.dealAccountInfoJson.arAccountNumbers) {
                this.store.dealAccountInfoJson.arAccountNumbers = { accountNumber: [] };
            }
            // Add AR Account Number
            if (isAdd) {
                if (this.accountNumber == '') {
                    this.showAlert(false, this.$t('accountList.alertAccountNumberIsRequired'));
                    return;
                }
                this.store.dealAccountInfoJson.arAccountNumbers.push(this.accountNumber);
                this.accountNumber = '';
                this.accountDialog.model = false;
            } else {
                this.deleteDialog.model = false;
                this.store.dealAccountInfoJson.arAccountNumbers = this.store.dealAccountInfoJson.arAccountNumbers.filter(item => item != this.accountNumber);

            }
        }

        if (
            this.selectedStore != null &&
            this.selectedStore !== '' &&
            this.selectedAccountType !== '' &&
            this.selectedAccountType != null
        ) {
            try {
                if (isAdd) {
                    this.accountDialog.loading = true;
                } else {
                    this.deleteDialog.loading = true;
                }
                await storeService.updateStoreInfo(
                    this.store,
                    Number(this.selectedStore),
                );
                this.getStoreById(this.selectedStore);
            } finally {
                this.accountDialog.loading = false;
                this.deleteDialog.loading = false;
                this.loading = false;
            }
        }
    }

    public updateAccountVariable() {
        if ( this.selectedAccountType != null && this.selectedAccountType !== '' && this.selectedAccountType == '1' ) {
            if (this.store != null &&  this.store.dealAccountInfoJson != null &&  this.store.dealAccountInfoJson.citAccountNumbers != null) {
            this.store.dealAccountInfoJson.citAccountNumbers.forEach(element => {
            const account = new AccountNumbersList();
            account.accountNumber = element;
            this.accounts.push(account);
            });
            }
        }
        if ( this.selectedAccountType != null && this.selectedAccountType !== '' &&   this.selectedAccountType == '2') {
            if (this.store != null &&  this.store.dealAccountInfoJson != null &&  this.store.dealAccountInfoJson.arAccountNumbers != null) {
                this.store.dealAccountInfoJson.arAccountNumbers.forEach(element => {
                const account = new AccountNumbersList();
                account.accountNumber = element;
                this.accounts.push(account);
            });
            }
        }
    }

    public deleteConfirmDialogOpen(accountNumber: string) {
        const values = Object.keys(accountNumber).map(key => accountNumber[key]);
        this.deleteDialog.model = true;
        this.accountNumber = values[0];
    }

    public showAccountDialog() {
        this.accountNumber = '';
        this.accountDialog.model = true;
        this.$validator.reset();
    }
    public closeAccountDialog() {
        this.accountDialog.model = false;
        this.$validator.reset();
    }
}
